import script from "./templates-flashvolve.vue?vue&type=script&setup=true&lang=js"
export * from "./templates-flashvolve.vue?vue&type=script&setup=true&lang=js"

import "./templates-flashvolve.vue?vue&type=style&index=0&id=dad46be6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dad46be6"]])

export default __exports__